import React, { useMemo } from 'react';
import { SelectProps } from './Select.types';
import { Flex, Text, Box } from '../../index.ts';
import { SelectBase } from './Select.ui';
import { SelectDropdownIcon } from '@keyslabor/shared/assets';
import { useIsMobile } from '../../../hooks/useBreakPoint.ts';

export interface Option {
  value: string | number;
  label: string;
}

function renderDropdownMenu({ menu }) {
  const maxHeight = 200; // Set a maximum height for the menu

  // Get the number of options and calculate the height
  const numOptions = menu?.props?.children?.length;
  const height = Math.min(numOptions * 32, maxHeight);

  // Set the style for the menu
  const style = {
    maxHeight: `${height}px`,
    overflowY: 'auto',
  };

  // Render the custom menu
  return <div>{menu}</div>;
}

export default function Select({
  name,
  width,
  height,
  label,
  labelType = 'default',
  required,
  onChange,
  options,
  showSearch,
  margin,
  placeholder,
  color,
  mode,
  value,
  labelFontSize,
  defaultValue,
  ...restProps
}: SelectProps) {
  const isMobile = useIsMobile();
  const filteredOptions = useMemo(() => options, [options]);

  return (
    <Flex position={'relative'} margin={margin} flexDirection="column">
      {labelType !== 'material' && label ? (
        <Flex>
          <Text fontSize={isMobile ? '16px' : '14px'} fontWeight={'500'}>
            {label}
          </Text>
          {required ? (
            <Text color="#EB5757" ml="2px" mb="6px">
              *
            </Text>
          ) : null}
        </Flex>
      ) : null}

      {labelType === 'material' && (
        <Box
          position="absolute"
          display="block"
          zIndex={999999}
          top="-11px"
          left="16px"
          backgroundColor={'#fff'}
          p="0px 5px"
        >
          <Text
            fontSize="12px"
            fontWeight="400"
            color="rgba(0, 0, 0, 0.6)"
            lineHeight="16px"
          >
            {label}
          </Text>
        </Box>
      )}
      <SelectBase
        name={name}
        width={width}
        height={height || '55px'}
        filterOption={(input, option) => (option?.label ?? '').includes(input)}
        notFoundContent={null}
        placeholder={placeholder}
        value={value}
        // defaultValue={!placeholder ? options && options[0] : null}
        options={filteredOptions}
        onChange={onChange}
        color={color}
        showSearch={true}
        mode={mode}
        // onSearch={handleSearch}
        suffixIcon={<SelectDropdownIcon />}
        {...restProps}
      />
    </Flex>
  );
}
